import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Dumbbell, TrendingUp, Calendar, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BottomNav = () => {
  const location = useLocation();
  const path = location.pathname;
  const { t } = useTranslation();

  return (
    <nav className="bottom-nav">
      <Link to="/dashboard" className={`nav-item ${path === '/dashboard' ? 'active' : ''}`} data-testid="nav-dashboard">
        <Dumbbell />
        <span>{t('nav.routines')}</span>
      </Link>
      <Link to="/progress" className={`nav-item ${path === '/progress' ? 'active' : ''}`} data-testid="nav-progress">
        <TrendingUp />
        <span>{t('nav.progress')}</span>
      </Link>
      <Link to="/calendar" className={`nav-item ${path === '/calendar' ? 'active' : ''}`} data-testid="nav-calendar">
        <Calendar />
        <span>{t('nav.history')}</span>
      </Link>
      <Link to="/profile" className={`nav-item ${path === '/profile' ? 'active' : ''}`} data-testid="nav-profile">
        <User />
        <span>{t('nav.profile')}</span>
      </Link>
    </nav>
  );
};

export default BottomNav;
